import { erpAxios } from '.';

const replacementLoans = async (clientId) => {
  const { data } = await erpAxios.get(`/loanReleaseAnalytics/replacementLoans/${clientId}`);
  return data;
};

export default replacementLoans;
